import { FC } from 'react'
import { Typography, Button, Tooltip, ButtonProps } from '@mui/material'
import CheckMark from '../../../../../assets/images/check-mark.svg?react'
import PlayChapterIcon from '../../../../../assets/images/play-chapter-icon.svg?react'
import { formatActivityCardTime, formatActivityCardTimeWithMs } from '../../activityUtils'

type ActivityDurationButtonProps = ButtonProps & {
  isInteractive?: boolean
  isPlayingChapter?: boolean
  isScrubberWithinActivity?: boolean
  durationMs: number
}

export const ActivityDurationButton: FC<ActivityDurationButtonProps> = ({
  isInteractive = false,
  isPlayingChapter,
  isScrubberWithinActivity,
  durationMs,
  ...buttonProps
}) => {
  const { sx, ...restButtonProps } = buttonProps

  const getBackgroundColor = () => {
    if (isInteractive) {
      return isScrubberWithinActivity ? 'var(--bg-surface-warning)' : 'var(--bg-surface-warning-transparent)'
    }
    return isPlayingChapter ? 'var(--indicators-badge-grey, rgba(82, 82, 83, 0.40))' : 'var(--button-primary-hover)'
  }

  const getTextColor = () => {
    if (isInteractive) {
      return isScrubberWithinActivity ? 'var(--text-inverted)' : 'var(--text-warning)'
    }
    return isPlayingChapter ? 'var(--text-inverted)' : 'var(--text-primary)'
  }

  const getHoverStyles = () => {
    if (isInteractive) {
      return {
        '&:hover': {
          color: 'var(--text-inverted)',
          backgroundColor: 'var(--bg-surface-warning)'
        }
      }
    }
    return {}
  }

  return (
    <Tooltip title={formatActivityCardTimeWithMs(durationMs)} arrow>
      <Button
        sx={{
          border: 'none',
          minWidth: '4.9rem',
          height: '2.5rem',
          borderRadius: 'var(--spacing-2xs)',
          padding: 'var(--spacing-xs) var(--spacing-2xs)',
          gap: 'var(--spacing-2xs)',
          alignItems: 'center',
          backgroundColor: getBackgroundColor(),
          color: getTextColor(),
          cursor: isInteractive ? 'pointer' : 'default',
          ...getHoverStyles(),
          ...sx
        }}
        {...restButtonProps}
      >
        {isInteractive ? <PlayChapterIcon /> : <CheckMark />}
        <Typography sx={{ fontWeight: '500', fontSize: 'var(--size-2xs)' }}>{formatActivityCardTime(durationMs / 1000)}</Typography>
      </Button>
    </Tooltip>
  )
}
